import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=5dd84899&"
import script from "./Project.vue?vue&type=script&lang=ts&"
export * from "./Project.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd84899')) {
      api.createRecord('5dd84899', component.options)
    } else {
      api.reload('5dd84899', component.options)
    }
    module.hot.accept("./Project.vue?vue&type=template&id=5dd84899&", function () {
      api.rerender('5dd84899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Project.vue"
export default component.exports